import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatPaginator,
} from "@angular/material";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PartnerData } from "../../../_models/index";
@Component({
  selector: "app-partners-management",
  templateUrl: "./partners-management.component.html",
  styleUrls: ["./partners-management.component.scss"],
})
export class PartnersManagementComponent implements OnInit {
  DisplayedColumns: string[] = [
    "PartnerId",
    "OperatorId",
    "OperatorName",
    "Currency",
    "Rate",
    "WalletType",
    "Status",
    "Action",
  ];

  partners = new MatTableDataSource();
  count: number = 0;
  searchUserName: string = "";
  constructor(
    private appService: AppService,
    private router: Router,
    private authService: AuthenticationService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getOurPartners();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getOurPartners() {
    try {
      this.appService.getOurPartners().subscribe((res) => {
        if (res.status === "RS_OK") {
          // this.partners.data = res.partners;
          this.partners = new MatTableDataSource<any>(res.partners);
          this.partners.paginator = this.paginator;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  handleClick(data) {
    try {
      let dialogRef = this.dialog.open(EditPartnersModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: { partnerData: data, title: "Edit Details" },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.isSuccess) {
          this.getOurPartners();
        }
      });
    } catch (err) {}
  }

  searchPartner(event) {
    const value = event.target.value;
    this.partners.filter = value.trim().toLocaleLowerCase();
  }

  addNewPartners(data) {
    try {
      this.dialog.open(AddPartnerModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: { title: "Add New Partner", operatorId: data.operator_id },
      });
    } catch (err) {}
  }

  handleChangeStatus(e, partner) {
    if (e.checked) {
      this.appService
        .unBlockPartners(partner.operator_id, partner.partner_id)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.getOurPartners();
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService
        .blockPartners(partner.operator_id, partner.partner_id)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.getOurPartners();
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./partners-edit-modal.html",
  styleUrls: ["./partners-management.component.scss"],
})
export class EditPartnersModalComponent {
  editForm: FormGroup;
  loading = false;
  submitted = false;
  data: any;
  btnDisable = true;

  constructor(
    public dialogRef: MatDialogRef<EditPartnersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public partnerData,
    private formBuilder: FormBuilder,
    private appService: AppService
  ) {
    this.data = partnerData;
  }
  ngOnInit() {
    this.editForm = this.formBuilder.group({
      OperatorId: [this.data.partnerData.operator_id, Validators.required],
      OperatorName: [this.data.partnerData.operator_name, Validators.required],
      Currency: [this.data.partnerData.currency, Validators.required],
      Rate: [this.data.partnerData.rate, Validators.required],
      Status: [this.data.partnerData.status, Validators.required],
      PartnerId: [this.data.partnerData.partner_id, Validators.required],
    });
  }
  handleChange(e) {
    this.btnDisable = false;
  }

  get f() {
    return this.editForm.controls;
  }

  onSubmit() {
    let editData = {
      OperatorId: this.data.partnerData.operator_id,
      OperatorName: this.data.partnerData.operator_name,
      partnerId: this.data.partnerData.partner_id,
      Status: this.data.partnerData.status,
      WalletType: this.data.partnerData.wallet_type,
      Rate: this.f.Rate.value,
    };
    try {
      this.appService.updatePartner(editData).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close({ isSuccess: true });
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {}
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./add-partner-modal.html",
  styleUrls: ["./add-partner.component.scss"],
})
export class AddPartnerModalComponent {
  title: string;
  operatorId: string;
  private status: string[];
  private partner: PartnerData;
  constructor(
    public dialogRef: MatDialogRef<AddPartnerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public Data,
    private appService: AppService
  ) {
    this.title = Data.title;
    this.operatorId = Data.operatorId;
  }
  operatorData = [];
  ngOnInit() {
    this.status = ["ACTIVE", "BLOCKED"];
    this.partner = new PartnerData({
      partnerId: "",
      operator_id: "",
      status: this.status[0],
      currency: "",
      rate: 0,
      Commisssion: 0,
    });
  }

  onFormSubmit({ value, valid }: { value: PartnerData; valid: boolean }) {
    this.partner = value;
    console.log("valid: " + valid);

    let postData = {
      operatorId: this.operatorId,
      ...{ partner: this.partner },
    };
    try {
      this.appService.addPartner(postData).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close();
          this.appService.openSuccessBar("Partner added successfully");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {
      console.log("err", err);
    }
  }
}
